import { GQLPlugin } from '../GQLTypes';

// eslint-disable-next-line
function reference (obj: any, str: string): string {
  return str.split('.').reduce((o, x) => {
    return o[x];
  }, obj);
}

export const LocalePlugin: GQLPlugin = (
  { beforeRequest },
  { store, localePath = 'locale', locale }
) => {
  beforeRequest.push(({ headers }) => {
    headers.set('Accept-Language', locale || reference(store.state, localePath));
  });
};
